import React from 'react';
import './index.less';

export const ImagePickerSkeletonShape = (
    <div className="ImagePickerSkeletonShape">
        <div className="rect" />
    </div>
);
